/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { HelpDataSearchData } from './HelpDataSearchData'
import {
  HelpDataSearchDataFromJSON,
  HelpDataSearchDataFromJSONTyped,
  HelpDataSearchDataToJSON,
} from './HelpDataSearchData'

/**
 *
 * @export
 * @interface HelpData
 */
export interface HelpData {
  /**
   *
   * @type {string}
   * @memberof HelpData
   */
  email?: string
  /**
   *
   * @type {string}
   * @memberof HelpData
   */
  phone?: string
  /**
   *
   * @type {string}
   * @memberof HelpData
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof HelpData
   */
  applicationId?: string
  /**
   *
   * @type {string}
   * @memberof HelpData
   */
  text?: string
  /**
   *
   * @type {string}
   * @memberof HelpData
   */
  registryPath?: string
  /**
   *
   * @type {string}
   * @memberof HelpData
   */
  registrySection?: string
  /**
   *
   * @type {string}
   * @memberof HelpData
   */
  sourceUrl?: string
  /**
   *
   * @type {HelpDataSearchData}
   * @memberof HelpData
   */
  searchData?: HelpDataSearchData
}

/**
 * Check if a given object implements the HelpData interface.
 */
export function instanceOfHelpData(value: object): value is HelpData {
  return true
}

export function HelpDataFromJSON(json: any): HelpData {
  return HelpDataFromJSONTyped(json, false)
}

export function HelpDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): HelpData {
  if (json == null) {
    return json
  }
  return {
    email: json['email'] == null ? undefined : json['email'],
    phone: json['phone'] == null ? undefined : json['phone'],
    name: json['name'] == null ? undefined : json['name'],
    applicationId:
      json['applicationId'] == null ? undefined : json['applicationId'],
    text: json['text'] == null ? undefined : json['text'],
    registryPath:
      json['registryPath'] == null ? undefined : json['registryPath'],
    registrySection:
      json['registrySection'] == null ? undefined : json['registrySection'],
    sourceUrl: json['sourceUrl'] == null ? undefined : json['sourceUrl'],
    searchData:
      json['searchData'] == null
        ? undefined
        : HelpDataSearchDataFromJSON(json['searchData']),
  }
}

export function HelpDataToJSON(value?: HelpData | null): any {
  if (value == null) {
    return value
  }
  return {
    email: value['email'],
    phone: value['phone'],
    name: value['name'],
    applicationId: value['applicationId'],
    text: value['text'],
    registryPath: value['registryPath'],
    registrySection: value['registrySection'],
    sourceUrl: value['sourceUrl'],
    searchData: HelpDataSearchDataToJSON(value['searchData']),
  }
}
